module.exports = __webpack_public_path__ + "img/49.25d8e62f.jpg";